<template>
  <div class="manager-video-banner mt-8">
    <div class="video-banner-card" @click="openVideo">
      <div class="banner-accent" />

      <div class="banner-content">
        <div class="play-button">
          <v-icon color="primary" size="36">mdi-play</v-icon>
        </div>

        <div class="banner-text">
          <div class="banner-title">Hello Managers!</div>
          <div class="banner-subtitle">
            Watch a short introduction to get familiar with the recruiting
            system
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RecruitingHomeIntroVideo',
  methods: {
    openVideo() {
      window.open(
        'https://vimeo.com/1145771385/ee00801615?share=copy&fl=sv&fe=ci',
        '_blank'
      );
    },
  },
};
</script>

<style scoped lang="less">
.video-banner-card {
  position: relative;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: @base-radius;
  box-shadow: @base-shadow;
  cursor: pointer;
  overflow: hidden;

  &:hover {
    border-color: var(--v-primary-base);
    background-color: #fafafa;
  }
}

.banner-accent {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 3px;
  background: var(--v-primary-base);
}

.banner-content {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 20px;

  @media (max-width: 680px) {
    padding: 14px 16px;
    gap: 14px;
  }
}

.play-button {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background-color: var(--v-primary-lighten5);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  @media (max-width: 680px) {
    width: 44px;
    height: 44px;
  }
}

.banner-text {
  min-width: 0;
}

.banner-title {
  font-size: 1.15rem;
  font-weight: 600;
  color: var(--v-appMain-base);
  margin-bottom: 4px;
}

.banner-subtitle {
  font-size: 0.95rem;
  color: rgba(0, 0, 0, 0.6);
  line-height: 1.4;
}
</style>
